import { FormControl, FormGroup } from '@angular/forms';
import { ITenant } from '@internal-models/tenant.model';
import { AddressFormFactory } from '@shared-factories/forms/address-form.factory';
import { SharedFormValidators } from '@shared-libs/form-validators';
import { IFormGroup } from '@shared-libs/interfaces';
import { IRegisterTenant } from '@shared-models/user.model';
import { isEmpty } from 'lodash';
import { EmployeeFormFactory } from './employee-form.factory';

export class TenantFormFactory {
	public static create(tenant: ITenant): IFormGroup<ITenant> {
		return new FormGroup({
			name: new FormControl(tenant.name, [SharedFormValidators.required]),
			description: new FormControl(tenant.description),
			logo: new FormControl(!isEmpty(tenant.logo) ? tenant.logo : './assets/imgs/digibank.png', [
				SharedFormValidators.required,
			]),
			favicon: new FormControl(!isEmpty(tenant.favicon) ? tenant.favicon : './assets/imgs/digibank_small.svg', [
				SharedFormValidators.required,
			]),
			email: new FormControl(tenant.email, [SharedFormValidators.required, SharedFormValidators.email]),
			telephone: new FormControl(tenant.telephone, [SharedFormValidators.phone]),
			Address: AddressFormFactory.createAsOptional(tenant.Address),
			intro: new FormControl(tenant.intro),
		}) as IFormGroup;
	}
	public static createForRegistration(): IFormGroup<IRegisterTenant> {
		return new FormGroup({
			name: new FormControl(null, [SharedFormValidators.required]),
			description: new FormControl(),
			Employee: EmployeeFormFactory.createForRegisterTenant(),
		}) as IFormGroup;
	}
}
